import { DateTime } from 'luxon';
import { TODO_TZ } from '@tradeoutlet/shared';

/** Quick reminder times for "Just remind me" (MessageTaskModal, t134). */
export interface RemindChoice { id: string; label: string; date: string; time: string }

/** "In 1 hour", "Later today", "Tomorrow morning", "Monday morning", all in UK time. */
export function remindChoices(now = DateTime.now().setZone(TODO_TZ)): RemindChoice[] {
  const at = (d: DateTime) => ({ date: d.toISODate()!, time: d.toFormat('HH:mm') });
  const hour = now.plus({ hours: 1 }).set({ second: 0, millisecond: 0 });
  const rounded = hour.plus({ minutes: (5 - (hour.minute % 5)) % 5 });
  const out: RemindChoice[] = [{ id: 'hour', label: `In 1 hour (${rounded.toFormat('HH:mm')})`, ...at(rounded) }];
  if (now.hour < 16) out.push({ id: 'later', label: 'Later today (17:00)', ...at(now.set({ hour: 17, minute: 0 })) });
  const tomorrow = now.plus({ days: 1 }).set({ hour: 9, minute: 0 });
  out.push({ id: 'tomorrow', label: `Tomorrow morning (${tomorrow.toFormat('ccc')} 09:00)`, ...at(tomorrow) });
  const monday = now.plus({ days: ((8 - now.weekday) % 7) || 7 }).set({ hour: 9, minute: 0 });
  if (monday.toISODate() !== tomorrow.toISODate()) out.push({ id: 'monday', label: `Next Monday (${monday.toFormat('d LLL')} 09:00)`, ...at(monday) });
  return out;
}
